import { css } from '@emotion/react'

/**
 * A span takes no width or height of its own until it is a box, and without
 * one an uploaded image draws at whatever size it was uploaded.
 */
export const frame = css({
  display: 'inline-flex',
})

export const image = css({
  borderRadius: 2,
  width: '100%',
  height: '100%',
})
